import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

// Hero background — exact image provided by the user (no edits, no re-render)
const heroImage = 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/a01f3039-f20b-4916-a511-da1112a025a5_compressed_Pincel-terracota-sobre-papel-beige.webp';

export default function ElManantialInterior() {
  const { t, i18n } = useTranslation();
  const hotmartUrl = i18n.language === 'en'
    ? 'https://pay.hotmart.com/X107377453R'
    : 'https://pay.hotmart.com/N107377382H';

  return (
    <div className="min-h-screen bg-cream">
      <Navbar overlayTone="dark" />

      {/* Hero — exact background image with title and two lines only */}
      <section className="relative w-full overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={heroImage}
            alt="Más allá de la maternidad"
            className="w-full h-full object-cover object-center"
          />
        </div>

        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 min-h-[520px] md:min-h-[660px] flex items-center justify-center lg:justify-start">
          <div className="max-w-xl lg:max-w-3xl text-center lg:text-left lg:ml-[34%] py-28 md:py-36">
            <h1 className="font-serif text-4xl md:text-5xl font-bold text-[#3D2B1F] leading-tight mb-5 lg:whitespace-nowrap">
              {t('mas_alla.manantial_hero_title')}
            </h1>
            <p className="font-sans text-base md:text-lg text-[#6B5443] leading-relaxed">
              {t('mas_alla.manantial_hero_line1')}
            </p>
            <p className="font-sans text-base md:text-lg text-[#6B5443] leading-relaxed mt-1">
              {t('mas_alla.manantial_hero_line2')}
            </p>
          </div>
        </div>
      </section>

      {/* Reseña corta — sobre fondo blanco, sin la tapa */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-white">
        <div className="w-full text-left">
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-[#3D2B1F] leading-tight mb-6">
            {t('mas_alla.manantial_review_title')}
          </h2>
          <p className="font-sans text-sm md:text-base text-[#5C4A3A] leading-relaxed mb-5">
            {t('mas_alla.manantial_review_p1')}
          </p>
          <p className="font-sans text-sm md:text-base text-[#5C4A3A] leading-relaxed mb-5">
            <strong className="font-semibold text-[#3D2B1F]">{t('mas_alla.libro1_title')}</strong>{' '}
            {t('mas_alla.manantial_review_p2')}
          </p>
          <p className="font-sans text-sm md:text-base text-[#5C4A3A] leading-relaxed mb-6">
            {t('mas_alla.manantial_review_p3')}
          </p>
          <p className="font-sans text-sm md:text-base text-[#3D2B1F] font-semibold leading-relaxed mb-8">
            {t('mas_alla.manantial_review_closing')}
          </p>
          <a
            href={hotmartUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-terracotta text-white px-6 py-3 rounded-full font-sans text-sm font-semibold hover:bg-brown transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            {t('mas_alla.manantial_buy')}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </section>

      {/* Legal Note */}
      <section className="py-10 md:py-14 px-6 md:px-10 bg-sand">
        <div className="w-full max-w-3xl mx-auto text-center">
          <p className="font-sans text-xs text-[#5C4A3A] leading-relaxed">
            {t('mas_alla.legal')}
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}